<template lang="pug">
  v-layout(wrap)
    v-chip(
      data-cy="attachment-chip"
      v-for='(file, index) in files'
      :key="file.name"
      @input="$emit('removeAttachment', file.name)"
      :close="canDelete(file)"
      :disabled="isDisabled"
      small
    )
      v-icon(small) attach_file
      | {{ file.name | truncate(12) }} ({{ file.size_bytes | fileSize }})
      div.bar-container(
        v-if="file.progress !== undefined && file.progress !== 100 && showProgress"
      )
        div.bar(
          :style="handleProgress(file, index)"
          :ref="`progress-${file.name}`"
        )
</template>
<script>
import fileSize from '@/Core/filters/fileSize';
import truncate from '@/Core/filters/truncateText';

export default {
  name: 'AttachmentChips',
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: true,
    },
    showProgress: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    fileSize,
    truncate,
  },
  methods: {
    /**
     * allow user to delete a file if uploading is finished
     * or if the file was previously uploaded
     */
    canDelete(file) {
      if (!this.isDisabled) {
        return file.progress === 100 || !!file.id;
      }
      return false;
    },
    handleProgress(file) {
      const { name, progress } = file;
      const item = this.$refs[`progress-${name}`];
      if (!item || !item.length) return;
      const maxWidth = 167;
      const initialWidth = 20;
      const width = maxWidth * (progress / 100) + initialWidth;
      item[0].style.width = `${width}px`;
    },
    chipWidth(progress) {
      return progress !== 100 ? 'width: 194px;' : '';
    },
  },
};
</script>

<style scoped>
.bar-container {
  position: absolute;
  left: 0px;
}
.bar {
  height: 24px;
  width: 20px;
  border-radius: 28px;
  background-color: var(--v-primary-base);
  transition: all 0.5s linear;
  opacity: 0.3;
}
</style>
